module.exports = __webpack_public_path__ + "media/mem_new.3e4fa68b.mp4";